import { alertSuccess } from "../../utils/feedback";
import axiosInstance from "../../axios/index";
import { getOrganizatonProfiles } from "./organizationProfileCreators";
import { SET_USERS } from "../types/usersManagementTypes";
import { SET_LINK_ORGA, CLOSE_LINK_ORGA } from "../types/linkOrgaTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { fetchProfileNames } from "./profileNamesActionCreators";

export const setAllUsers = (users, total_pages, organizations) => ({
  type: SET_USERS,
  payload: { users, total_pages, organizations },
});

export const setLinkOrga = (data) => ({ type: SET_LINK_ORGA, payload: data });
export const closeLinkOrga = () => ({ type: CLOSE_LINK_ORGA, payload: false });

export const fetchAllUsers = (page, searchText, tabs, filter) => {
  return async (dispatch) => {
    dispatch(requestStarted("user"));
    try {
      const res = await axiosInstance.get(
        `/auth/users?page=${page}&search${
          searchText ? "=" + searchText : ""
        }&status${tabs !== "all" ? "=" + tabs : ""}&id${
          filter ? "=" + filter : ""
        }`
      );
      const { users } = res?.data;
      const { invited_users } = res?.data;
      const { pending_link } = res?.data;
      const { total_pages } = res?.data;
      const { organizations } = res?.data;
      dispatch(
        setAllUsers(
          [...users, ...invited_users, ...pending_link],
          total_pages,
          organizations
        )
      );
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error.response.data));
    }
  };
};

export const requestUpdatingUserRole = (id, value) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.put(`/auth/update_role/${id}`, {
        role: value,
      });
      dispatch(requestSucceeded());
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(fetchAllUsers(1, "", "all", null));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error.response.data));
    }
  };
};

export const requestAddingUser = (
  first_name,
  last_name,
  email,
  entreprise,
  role,
  page,
  text,
  tabs,
  filter,
  orgaId
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/auth/add_user`, {
        first_name: first_name,
        last_name: last_name,
        email: email,
        org_name: entreprise,
        role: role,
        org_profile_id: orgaId,
      });
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(requestSucceeded());
      dispatch(fetchAllUsers(page, text, tabs, filter));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestAddingUserForEnterprise = (
  first_name,
  last_name,
  email,
  role,
  managed_organizations,
  page,
  text,
  tabs,
  filter,
  handleClose,
  resetForm,
  handleOrganization
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = role ==="cytailor_admin"? await axiosInstance.post(`/auth/invite_super_admin`, {
        first_name: first_name,
        last_name: last_name,
        email: email,
        role: role,
      }) : await axiosInstance.post(`/auth/add_user`, {
        first_name: first_name,
        last_name: last_name,
        email: email,
        role: role,
        managed_organizations:
          role === "enterprise_risk_manager" ? null : managed_organizations,
      })
      dispatch(requestSucceeded());
      dispatch(fetchAllUsers(page, text, tabs, filter));
      handleClose();
      resetForm({ values: "" });
      handleOrganization({});
      if (res) {
        alertSuccess(res.data);
      }
    } catch (error) {
      if (error?.response?.status === 300) {
        dispatch(setLinkOrga(error.response.data));
        dispatch(requestSucceeded());
      } else {
        dispatch(requestFailed(error?.response?.data));
        handleClose();
        resetForm({ values: "" });
        handleOrganization({});
      }
    }
  };
};

export const confirmUser = (id, password, confirm_password, check, history) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/auth/confirm_added_user`, {
        id,
        password,
        confirm_password,
        check,
      });
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      history.push("/login");
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestRemovingUser = (id, page,
  searchText,
  tabs,
  filter) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.delete(`/auth/remove_user/${id}`);
      dispatch(requestSucceeded());
      dispatch(fetchAllUsers( page,
        searchText,
        tabs,
        filter));
      if (res.data) {
        alertSuccess(res.data);
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestCancelInvitation = (
  id,
  first_name,
  last_name,
  email,
  page,
  searchText,
  tabs,
  filter
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/auth/cancel_invitation`, {
        id,
        first_name,
        last_name,
        email,
      });
      dispatch(requestSucceeded());
      dispatch(fetchAllUsers(page, searchText, tabs, filter));
      if (res.data) {
        alertSuccess(res.data);
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestDissociationUser = ({
  id,
  first_name,
  last_name,
  email,
  page,
  searchText,
  status,
  tabs,
  filter,
}) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/auth/dissociation_an_account`, {
        id,
        first_name,
        last_name,
        email,
      });
      dispatch(requestSucceeded());
      dispatch(
        getOrganizatonProfiles(page || 1, searchText || "", status || "")
      );
      dispatch(fetchAllUsers(page, searchText, tabs, filter));
      if (res.data) {
        alertSuccess(res.data);
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestDeleteincompleteOrga = (
  id,
  first_name,
  last_name,
  email,
  page,
  searchText,
  status
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/auth/delete_free_account`, {
        id,
        first_name,
        last_name,
        email,
      });
      dispatch(requestSucceeded());
      dispatch(getOrganizatonProfiles(page, searchText, status));
      dispatch(fetchProfileNames());
      dispatch(fetchAllUsers(1, "", "all", null));
      if (res.data) {
        alertSuccess(res.data);
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestLinkOrganization = (
  admin_uid,
  role,
  email,
  first_name,
  last_name,
  managed_organizations,
  page,
  searchText,
  tabs,
  filter
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/auth/invite_enterprise_user`, {
        admin_uid,
        role,
        email,
        first_name,
        last_name,
        managed_organizations,
      });
      dispatch(requestSucceeded());
      dispatch(fetchAllUsers(page, searchText, tabs, filter));
      dispatch(getOrganizatonProfiles(1, "", ""));
      alertSuccess(res.data);
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
